import { useNavigate, useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Label } from "recharts";

function Dashboard() {
  const [datos, setDatos] = useState([]);
  const navigate = useNavigate();
  const BASE_URL = useOutletContext();
  useEffect(() => {
    fetch(`${BASE_URL}/models.php`, {
      method: 'POST', // 👈 importante
      headers: {
        'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
      },
      body: JSON.stringify({ page:'dashBoard'})
    })
    .then((res) => {
      if (!res.ok) throw new Error("Token inválido");
      return res.json();
    })
    .then((data) => setDatos(data))
    .catch((err) => {
      console.error("Error al obtener datos:", err);
      navigate("/login");
    })
}, [navigate, BASE_URL]);

return (
  <div>
    <center>
      <h1>📈 Dashboard</h1>

      <h2>Cantidad Streamer Cobrando por semana</h2>
    </center>
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={datos}>
        <XAxis dataKey="Fecha">
          <Label value="Fecha de corte" offset={-5} position="insideBottom" />
        </XAxis>
        <YAxis domain={[0, 'auto']}>
          <Label
            value="Cantidad cobrando" angle={-90} position="insideLeft" />
        </YAxis>
        <Tooltip />
        <Line type="linear" dataKey="Contador" stroke="blue" />
      </LineChart>
    </ResponsiveContainer>
  </div>
);
}

export default Dashboard;